import Vue from "vue";
import VueI18n from "vue-i18n"
Vue.use(VueI18n)

// default
import defaultMessages from "../../lang"
import { langHelper, availableLanguages } from "../../plugins/lang"
let defaultLocale = langHelper.getDefault()

// initial state
const state = () => ({
    availableLanguages: availableLanguages,
    displayLanguage: defaultLocale,
    messages: defaultMessages,
    i18n: new VueI18n({
        locale: defaultLocale,
        messages: defaultMessages
    })
})

// getters
const getters = {
    i18n: (state) => {
        return state.i18n
    }
}

// actions
const actions = {
    setAvailableLanguages ({ commit }, langs) {
        commit('setAvailableLanguages', { langs })
    },
    setDefaultLanguage({ dispatch }) {
        dispatch('setLanguage', defaultLocale)
    },
    setLanguage ({ commit, dispatch, state }, lang) {
        if (state.availableLanguages.includes(lang)) {
            // i18n
            state.i18n.locale = lang
            // state
            commit('setLanguage', { lang })
            // cookie
            langHelper.setCookie(lang)
            // API
            dispatch('api/setLanguage', lang, { root: true })
            // Importer API
            dispatch('importerApi/setLanguage', lang, { root: true })
            // html tag
            document.documentElement.lang = lang
        }
    },
    addTranslations ({ commit }, messages) {
        commit('addTranslations', { messages })
    }
}

// mutations
const mutations = {
    setAvailableLanguages (state, { langs }) {
        // state
        state.availableLanguages = langs
    },
    setLanguage (state, { lang }) {
        state.displayLanguage = lang
    },
    addTranslations (state, { messages }) {
        // state
        let _ = require('lodash')
        state.messages = _.merge(state.messages, messages)
        // i18n
        for (let lang in state.messages) {
            state.i18n.setLocaleMessage(lang, state.messages[lang])
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}